export default "__VITE_ASSET__e8e562d6__"